import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { type ReactNode, useMemo } from 'react'

import { BRPCarouselLayout } from '@/components/brp/BRPCarouselLayout'
import { PopularMakesTile } from '@/components/brp/PopularMakesTile'
import { TRANSLATION_KEYS } from '@/constants/localization'
import { getPopularMakesData } from '@/features/search/utils/vertical-brp/getPopularMakesData'
import { trackEvent } from '@/lib/ga'
import { GA_EVENT } from '@/lib/ga/constants/gaEvent'

export const PopularMakesCarousel = () => {
  const { query } = useRouter()
  const { t } = useTranslation(TRANSLATION_KEYS.SRP)

  const data = useMemo(() => getPopularMakesData(t, query), [t, query])

  const handleTileClick = (tileLabel: string) => {
    trackEvent({
      action: GA_EVENT.BRPCarouselClick,
      label: `page=brp_landing_page;section=popular_makes;tile=${tileLabel}`,
    })
  }

  const slides: ReactNode[] = data.map((item) => {
    const { label, url, imgSrc } = item

    return (
      <PopularMakesTile
        key={label}
        label={label}
        url={url}
        imageSrc={imgSrc}
        onClick={handleTileClick}
      />
    )
  })

  return (
    <BRPCarouselLayout
      title={t('search_by_popular_makes.carousel.title')}
      carouselName="popular-makes"
      slides={slides}
      shouldShowArrows={true}
      slideCustomStyle="flex-basis: 0 !important"
    />
  )
}
